import { convertAngleToDirection } from "./utils";

export class DPadDayHandler {
    constructor(element, outputPrefix) {
        this.outputPrefix = outputPrefix;
        this.lastDirection = "";
        this.previous = "";
        this.pressed = false;
        this.centerRadius = 0.5;
        this.el = element;
        this.deadzone = 0.82;

        this.emitDPad4 = this.emitDPad4.bind(this);
        this.press = this.press.bind(this);
        this.unpress = this.unpress.bind(this);
    }

    addEventListeners() {
        this.el.addEventListener("axismove", this.emitDPad4);
        this.el.addEventListener("trackpaddown", this.press);
        this.el.addEventListener("trackpadup", this.unpress);
    }

    removeEventListeners() {
        this.el.removeEventListener("axismove", this.emitDPad4);
        this.el.removeEventListener("trackpaddown", this.press);
        this.el.removeEventListener("trackpadup", this.unpress);
    }

    press() {
        this.pressed = true;
    }

    unpress() {
        this.pressed = false;
    }

    emitDPad4(event) {
        event.detail.axis[1] *= -1.2;
        const xAxis = event.detail.axis[0];
        const yAxis = event.detail.axis[1];

        if (
            Math.abs(xAxis) < this.deadzone &&
            Math.abs(yAxis) < this.deadzone &&
            !this.pressed
        ) {
            event.target.emit("move", event.detail);
            return;
        }

        if (!event.detail.changed[0] && !event.detail.changed[1]) {
            return;
        }

        const position =
            Math.abs(xAxis) < this.centerRadius &&
            Math.abs(yAxis) < this.centerRadius
                ? "center"
                : convertAngleToDirection(Math.atan2(xAxis, -yAxis));
        const state = (this.pressed ? "pressed_" : "") + position;

        if (xAxis === 0 && yAxis === 0) {
            event.target.emit(`${this.outputPrefix}_dpad4_${this.previous}_up`);
            event.target.emit(`${this.outputPrefix}_dpad4_up`);
            this.previous = "";
            return;
        }

        if (state !== this.previous) {
            if (this.previous !== "") {
                event.target.emit(
                    `${this.outputPrefix}_dpad4_${this.previous}_up`
                );
            }
            event.target.emit(`${this.outputPrefix}_dpad4_${state}_down`);
            this.previous = state;
        }
    }
}
